import {
  FormControl,
  FormControlLabel,
  FormControlProps,
  Stack,
  Typography,
} from "@mui/material";
import { ReactElement, ReactNode } from "react";

interface InputProps {
  label: string;
  children: ReactNode;
  type: "input";
  labelWidth?: number;
  formControlProps?: FormControlProps;
}

interface CheckboxProps {
  type: "checkbox";
  label: string;
  children: ReactElement;
}

type Props = InputProps | CheckboxProps;

const DrawerFieldRow = (props: Props) => {
  if (props.type === "input") {
    const { children, label, labelWidth, formControlProps } = props;

    return (
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        gap={2}
      >
        <Typography fontWeight={700} sx={{ width: labelWidth, flexShrink: 0 }}>
          {label}
        </Typography>
        <FormControl sx={{ width: 300, minWidth: 0 }} {...formControlProps}>
          {children}
        </FormControl>
      </Stack>
    );
  }

  if (props.type === "checkbox") {
    const { children, label } = props;

    return (
      <FormControlLabel
        sx={{
          alignItems: "center",
          gap: 1,
          margin: 0,

          "& .MuiFormControlLabel-label": {
            fontSize: "14px",
          },
        }}
        control={children}
        label={label}
      />
    );
  }
};

export default DrawerFieldRow;
